module.exports = __webpack_public_path__ + "img/avatar-10.fb9b221a.jpg";